export const id = {
  "app.title": "survivrr.io",
  "menu.online": "Online",
  "menu.offline": "Offline",
  "menu.play": "Main",
  "menu.name": "Nama",
  "menu.ballColor": "Warna bola",
  "menu.nameColor": "Warna nama",
  "menu.moreInfo": "Info lainnya",
  "menu.moreInfoTitle": "Info lainnya",
  "menu.moreInfoSubtitle": "Halaman hukum, detail cookie, dan informasi kontak.",
  "menu.back": "Kembali",
  "menu.privacySettings": "Pengaturan privasi",
  "menu.cookiePolicy": "Kebijakan cookie",
  "menu.privacyPolicy": "Kebijakan privasi",
  "menu.termsOfService": "Ketentuan layanan",
  "menu.emailButton": "Kirim e-mail",
  "menu.websiteButton": "Lihat situs saya",
  "menu.contactEmailLabel": "E-mail kontak:",
  "menu.emailLabel": "E-mail:",
  "menu.websiteLabel": "Lihat situs saya:",
  "menu.nameRequired": "Masukkan nama terlebih dahulu.",
  "moreInfo.privacySettings.intro1": "Anda dapat mengelola pilihan privasi di situs ini melalui pesan persetujuan yang ditampilkan oleh penyedia iklan kami saat tersedia.",
  "moreInfo.privacySettings.intro2": "Anda juga dapat mengontrol cookie dan penyimpanan lokal kapan saja melalui pengaturan browser.",
  "moreInfo.privacySettings.adsHeading": "Kontrol iklan",
  "moreInfo.privacySettings.adsParagraph": "Beberapa iklan dapat disediakan oleh Google atau mitra lain. Pilihan iklan yang dipersonalisasi juga dapat dikelola langsung di pengaturan iklan Google.",
  "moreInfo.privacySettings.adsBullet1": "Buka kontrol iklan Google di myadcenter.google.com.",
  "moreInfo.privacySettings.adsBullet2": "Hapus cookie atau data situs jika ingin mengatur ulang pilihan persetujuan.",
  "moreInfo.privacySettings.adsBullet3": "Gunakan pengaturan privasi browser untuk memblokir atau membatasi cookie.",
  "moreInfo.privacySettings.localHeading": "Pengaturan lokal",
  "moreInfo.privacySettings.localParagraph": "Game ini menyimpan preferensi lokal dasar seperti nama pemain, warna, preferensi suara, dan bahasa agar situs dapat mengingatnya di perangkat Anda.",
  "moreInfo.cookiePolicy.intro1": "Situs ini menggunakan cookie dan teknologi penyimpanan serupa untuk menjalankan game, mengingat pengaturan Anda, dan mendukung iklan.",
  "moreInfo.cookiePolicy.intro2": "Cookie juga dapat digunakan untuk pengukuran, pencegahan penipuan, dan personalisasi iklan tergantung pilihan persetujuan Anda dan layanan yang diaktifkan di situs.",
  "moreInfo.cookiePolicy.typesHeading": "Jenis cookie dan penyimpanan yang dapat kami gunakan",
  "moreInfo.cookiePolicy.typeBullet1": "Penyimpanan penting yang digunakan agar situs tetap berjalan.",
  "moreInfo.cookiePolicy.typeBullet2": "Penyimpanan preferensi untuk mengingat nama, warna, bahasa, dan pengaturan suara.",
  "moreInfo.cookiePolicy.typeBullet3": "Cookie iklan atau pengukuran yang digunakan oleh mitra iklan seperti Google saat iklan diaktifkan.",
  "moreInfo.cookiePolicy.manageHeading": "Cara mengelola cookie",
  "moreInfo.cookiePolicy.manageParagraph": "Anda dapat mengelola cookie melalui pesan persetujuan di situs saat tersedia, atau melalui pengaturan browser. Menonaktifkan beberapa cookie dapat memengaruhi fitur situs atau penayangan iklan.",
  "moreInfo.privacyPolicy.intro1": "Situs ini adalah game browser yang dioperasikan oleh Michał Kierzkowski. Kami berusaha mengumpulkan sesedikit mungkin informasi pribadi.",
  "moreInfo.privacyPolicy.intro2": "Tidak diperlukan akun untuk bermain. Game dapat menyimpan preferensi lokal dasar di perangkat Anda dan memproses data gameplay yang diperlukan untuk pertandingan online.",
  "moreInfo.privacyPolicy.infoHeading": "Informasi yang dapat kami proses",
  "moreInfo.privacyPolicy.infoBullet1": "Nama pemain yang Anda pilih dan pengaturan kosmetik.",
  "moreInfo.privacyPolicy.infoBullet2": "Data sesi dasar yang diperlukan untuk menjalankan fitur multipemain.",
  "moreInfo.privacyPolicy.infoBullet3": "Data perangkat, browser, atau iklan yang dikumpulkan oleh mitra analitik atau iklan jika layanan tersebut diaktifkan.",
  "moreInfo.privacyPolicy.useHeading": "Cara kami menggunakan informasi",
  "moreInfo.privacyPolicy.useBullet1": "Untuk menjalankan game dan ruang online.",
  "moreInfo.privacyPolicy.useBullet2": "Untuk mengingat pengaturan Anda di perangkat.",
  "moreInfo.privacyPolicy.useBullet3": "Untuk meningkatkan performa, keamanan, dan stabilitas.",
  "moreInfo.privacyPolicy.useBullet4": "Untuk menampilkan iklan saat iklan diaktifkan.",
  "moreInfo.privacyPolicy.contactHeading": "Kontak",
  "moreInfo.privacyPolicy.contactParagraph1": "Jika Anda memiliki pertanyaan terkait privasi, hubungi: mjkierzkowski@gmail.com",
  "moreInfo.privacyPolicy.contactParagraph2": "Situs web: michalkierzkowski.com",
  "moreInfo.terms.intro1": "Dengan menggunakan situs ini, Anda setuju untuk menggunakan game secara legal dan adil.",
  "moreInfo.terms.intro2": "Game disediakan apa adanya dan dapat berubah, terganggu, atau dihapus kapan saja.",
  "moreInfo.terms.rulesHeading": "Aturan",
  "moreInfo.terms.ruleBullet1": "Jangan menyalahgunakan bug, cheat, otomatisasi, atau exploit.",
  "moreInfo.terms.ruleBullet2": "Jangan mencoba merusak layanan atau pemain lain.",
  "moreInfo.terms.ruleBullet3": "Jangan menggunakan nama atau konten yang menyinggung, ilegal, atau menyesatkan.",
  "moreInfo.terms.limitationHeading": "Batasan",
  "moreInfo.terms.limitationParagraph": "Kami tidak bertanggung jawab atas kerugian, gangguan, atau kerusakan yang timbul dari penggunaan situs sejauh diizinkan oleh hukum.",
  "moreInfo.terms.changesHeading": "Perubahan",
  "moreInfo.terms.changesParagraph": "Ketentuan ini dapat diperbarui di masa mendatang. Terus menggunakan situs setelah pembaruan berarti Anda menerima ketentuan yang diperbarui.",
  "status.offline": "Memulai pertandingan offline...",
  "status.connecting": "Menghubungkan ke server...",
  "queue.title": "Menunggu ruang",
  "queue.menu": "Kembali ke menu utama",
  "game.pressToMove": "Tekan di mana saja untuk bergerak",
  "game.touchToMove": "Sentuh di mana saja untuk bergerak",
  "game.leaderboard": "Papan peringkat",
  "game.hp": "HP",
  "game.level": "Level",
  "game.xp": "XP",
  "game.respawning": "Respawn...",
  "gameEnd.title": "Game berakhir",
  "gameEnd.winTitle": "Anda menang",
  "gameEnd.subtitle": "Pertandingan telah berakhir. Respawn untuk memulai ronde berikutnya atau kembali ke menu.",
  "pause.title": "Menu game",
  "pause.resume": "Lanjutkan",
  "pause.menu": "Kembali ke menu utama",
  "upgrade.title": "Pilih upgrade",
  "upgrade.generic.title": "Upgrade",
  "upgrade.generic.description": "Tingkatkan build Anda.",
  "upgrade.newWeaponPrefix": "Senjata baru:",
  "upgrade.stat.maxHp.title": "HP maksimum",
  "upgrade.stat.maxHp.description": "Meningkatkan HP maksimum.",
  "upgrade.stat.speed.title": "Kecepatan gerak",
  "upgrade.stat.speed.description": "Meningkatkan kecepatan gerak.",
  "upgrade.stat.generic.title": "Upgrade stat",
  "upgrade.stat.generic.description": "Tingkatkan stat Anda.",
  "upgrade.weapon.projectileShot.title": "Tembakan proyektil",
  "upgrade.weapon.projectileShot.description": "Tambahkan tembakan proyektil ke build Anda.",
  "upgrade.weapon.orbitingBalls.title": "Bola orbit",
  "upgrade.weapon.orbitingBalls.description": "Tambahkan bola orbit ke build Anda.",
  "upgrade.weapon.damageZone.title": "Zona damage",
  "upgrade.weapon.damageZone.description": "Tambahkan zona damage di sekitar karakter.",
  "upgrade.weapon.generic.title": "Senjata",
  "upgrade.weapon.generic.description": "Tambahkan senjata ini ke build Anda.",
  "upgrade.weaponUpgrade.frequency.title": "Frekuensi",
  "upgrade.weaponUpgrade.frequency.description": "Serang lebih sering.",
  "upgrade.weaponUpgrade.range.title": "Jangkauan",
  "upgrade.weaponUpgrade.range.description": "Meningkatkan jangkauan senjata.",
  "upgrade.weaponUpgrade.projectileCount.title": "Jumlah proyektil",
  "upgrade.weaponUpgrade.projectileCount.description": "Membuat lebih banyak proyektil.",
  "upgrade.weaponUpgrade.projectileSpeed.title": "Kecepatan proyektil",
  "upgrade.weaponUpgrade.projectileSpeed.description": "Membuat proyektil lebih cepat.",
  "upgrade.weaponUpgrade.orbitalSpeed.title": "Kecepatan orbit",
  "upgrade.weaponUpgrade.orbitalSpeed.description": "Membuat bola orbit berputar lebih cepat.",
  "upgrade.weaponUpgrade.damage.title": "Damage",
  "upgrade.weaponUpgrade.damage.description": "Memberikan lebih banyak damage.",
  "upgrade.weaponUpgrade.generic.title": "Upgrade senjata",
  "upgrade.weaponUpgrade.generic.description": "Tingkatkan senjata ini.",
  "defeat.title": "Kalah",
  "defeat.subtitle": "Respawn atau kembali ke menu",
  "defeat.respawn": "Respawn",
  "defeat.menu": "Menu utama",
  "error.generic": "Terjadi kesalahan.",
} as const;
